var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modalKeyword","centered":""},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var cancel = ref.cancel;
return [_c('b-button',{staticClass:"btn-cancel",on:{"click":function () {
          _vm.getArea();
          cancel();
        }}},[_vm._v(" Cerrar ")])]}}])},[_c('div',{},[_c('h5',{staticClass:"mb-3"},[_vm._v("Agregar una nueva palabra clave")]),_c('NewKeyword')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }